import { SxProps } from '@mui/material';
import { ContentCard, Props } from './ContentCard';

interface FormCardProps extends Props {
  sx?: SxProps;
}

export const FormCard = ({ sx, ...props }: FormCardProps) => {
  return (
    <ContentCard
      sx={{
        px: '24px',
        pb: '24px',
        pt: '16px',
        ...sx
      }}
      {...props}
    />
  );
};
